import { Injectable, OnDestroy } from '@angular/core';
import { environment } from '@siat-fe/env';
import { Subject, Subscription, timer } from 'rxjs';
import { GetLastActivity } from './storage-data.utility';

@Injectable({
  providedIn: 'root',
})
export class IdleUserService implements OnDestroy {
  /**
   * Idle user time.
   */
  private idleUserTime = {
    idleTime: environment.idleTime,
    countdownTime: 10000, // 10 seconds countdown.
  };

  /**
   * Idle timer subscription.
   */
  private idleTimerSub?: Subscription;

  /**
   * Countdown subscription.
   */
  private countdownSub?: Subscription;

  /**
   * Countdown value.
   */
  private countdownValue!: number;

  /**
   * User inactive subject..
   */
  userInactive: Subject<boolean> = new Subject<boolean>();

  constructor() {
    this.startTimer();
  }
  /**
   * Start the idle timer.
   */
  startTimer(): void {
    const timeElapsed = Date.now() - new Date(GetLastActivity()).getTime();
    if (timeElapsed > this.idleUserTime.idleTime) {
      this.startCountdown();
    } else {
      this.idleTimerSub = timer(
        this.idleUserTime.idleTime - timeElapsed
      ).subscribe(() => this.startCountdown());
    }
  }

  /**
   * Start the countdown timer.
   */
  startCountdown(): void {
    this.countdownValue = this.idleUserTime.countdownTime / 1000;
    this.countdownSub = timer(1000, 1000).subscribe(() => {
      this.countdownValue--;
      if (this.countdownValue <= 0) {
        this.userInactive.next(true);
        this.countdownSub?.unsubscribe();
      }
    });
  }

  /**
   * Reset the idle timer.
   */
  reset(): void {
    this.idleTimerSub?.unsubscribe();
    this.countdownSub?.unsubscribe();
    this.startTimer();
  }

  ngOnDestroy(): void {
    this.idleTimerSub?.unsubscribe();
    this.countdownSub?.unsubscribe();
  }
}
